module.exports = {
  emptyMessage: 'Por favor, ingresa la fecha de vencimiento de tu tarjeta.',
  expiredMessage: '¡Ups! La tarjeta que informaste ha expirado.',
  defaultMessage: 'La fecha de vencimiento no es válida.',
};
